<template>
<div class="content">
	<!-- Content Header (Page header) -->
	<section class="content-header">
		<div class="container-fluid">
				<div class="page-header clearfix">
				<h1>{{ $t($route.name) }}</h1>
				<div class="pull-right">
					<router-link data-toggle="tooltip" title="Назад" class="btn btn-default" to="/material/list"><i class="fa fa-arrow-left"></i></router-link>
					<router-link data-toggle="tooltip" title="Редактирай" class="btn btn-info" :to="'/material/' + material.id + '/edit'" v-if="canEdit"><i class="fa fa-pencil"></i></router-link>
				</div>
			</div>
		</div>
	</section>
	<!-- Main Content -->
	<div class="container-fluid" v-if="dataReady">

		<div class="card">
			<div class="card-header clearfix">
				<h4 class="card-title pull-left">
					<!-- <img :src="material.image || '/network/static/img/default.jpg'" style="width: 40px; margin-right: 1rem"> -->
					{{ material.title }}
				</h4>
				<a :href="material.link" class="btn btn-primary btn-icon pull-right" target="_blank"><i class="fa fa-file-text"></i> Отвори</a>
			</div>
			<div class="card-block">
				<p style="white-space: pre-line">
					<strong>Описание:</strong>
					{{ material.description }}
				</p>
				<hr>
				<p>
					<strong>Предоставен от:</strong>
					<div class="clearfix">
						<c-avatar v-for="family in material.families" :family="family" class="float-left"></c-avatar>
					</div>
				</p>
			</div>
		</div><!--	end card	-->

	</div>
</div>
</template>

<script>

module.exports = {
	data: function () {
		return {
			dataReady: false,
			material: {}
		};
	},
	created: function () {
		this.fetchData();
	},
	watch: {
		$route: 'fetchData'
	},
	computed: {
		canEdit: function () {
			if (!this.material.families) return false;
			for (var i = 0; i < this.material.families.length; i++) {
				if (this.material.families[i].id + '' === this.$user.familyUser.family.id + '') {
					return true;
				}
			}
			return false;
		}
	},
	methods: {
		fetchData: function () {
			this.$http.get('backend://material/' + this.$route.params.id).then((result) => {
				if (!result.body.error) {
					this.material = result.body;
					this.dataReady = true;
				}
			}).catch(this.$http.toastCatcher);
		}
	}
};

</script>
<style>

</style>



// WEBPACK FOOTER //
// MaterialView.vue?2668e241